import { render, staticRenderFns } from "./TargetingTimeSpentOnPage.vue?vue&type=template&id=47cdfbc7&"
import script from "./TargetingTimeSpentOnPage.vue?vue&type=script&lang=js&"
export * from "./TargetingTimeSpentOnPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports